import { Column, Skeleton, SkeletonBox } from "@hightouch/htui";
import { MediaDetailHeaderSkeleton } from "src/components/media-detail";
import { TilesSkeleton } from "src/pages/ad-studio/insights/tiles-skeleton";

export const EntityDrilldownSkeleton = () => (
  <Column gap={6}>
    <MediaDetailHeaderSkeleton />
    <Skeleton isLoading>
      <Column gap={6}>
        <TilesSkeleton />
        <SkeletonBox height={40} width="100%" borderRadius="md" />
      </Column>
    </Skeleton>
  </Column>
);
